import React from 'react';
import styles from './Winner.module.scss';

import Main from '../../components/Main/Main';
import Section from '../../components/Section/Section';

import Logo from '../../components/Logo/Logo';
import Button from '../../components/Button/Button';
import Confetti from 'react-confetti';
import Heading from '../../components/Heading/Heading';

const Winner = () => {
  return (
    <Main>
      <div className={styles.confetti}>
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={400}
          colors={['#0000ff', '#f0cc00']}
        />
      </div>
      <Section className={styles.content}>
        <Logo className={styles.logo} />
        <Heading>You did it! You caught them all!</Heading>
        <Button link={'/'}>Back to frontpage</Button>
      </Section>
    </Main>
  );
};

export default Winner;
